import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/dark-mode-protected.css"; // PROTECTED: Dark mode styles - DO NOT REMOVE
import "@/styles/light-mode-protected.css"; // PROTECTED: Light mode styles - DO NOT REMOVE
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// UNREGISTER Service Worker to clear cache issues (with Edge compatibility)
try {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then(function(registrations) {
        for(let registration of registrations) {
          registration.unregister();
        }
      })
      .catch(function(err) {
        // Silently ignore - Edge may block Service Worker access
      });
  }
} catch (e) {
  // Silently ignore Service Worker errors
}
